var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_4463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62212 3.66898L1.43212 4.13148L1.37562 4.14298C1.29009 4.16569 1.21211 4.21069 1.14966 4.27339C1.08721 4.33608 1.04252 4.41423 1.02015 4.49985C0.997776 4.58547 0.998529 4.67549 1.02233 4.76072C1.04613 4.84595 1.09212 4.92334 1.15562 4.98498L3.46662 7.23448L2.92162 10.412L2.91512 10.467C2.90988 10.5554 2.92825 10.6437 2.96834 10.7227C3.00843 10.8018 3.06881 10.8687 3.14328 10.9167C3.21776 10.9648 3.30366 10.9921 3.39219 10.996C3.48072 10.9999 3.5687 10.9803 3.64712 10.939L6.50012 9.43898L9.34662 10.939L9.39662 10.962C9.47915 10.9945 9.56884 11.0045 9.65649 10.9909C9.74415 10.9773 9.82661 10.9406 9.89541 10.8846C9.96422 10.8286 10.0169 10.7554 10.048 10.6723C10.0792 10.5892 10.0877 10.4994 10.0726 10.412L9.52712 7.23448L11.8391 4.98448L11.8781 4.94198C11.9338 4.87337 11.9704 4.79121 11.984 4.70388C11.9976 4.61655 11.9878 4.52717 11.9557 4.44485C11.9235 4.36253 11.8701 4.2902 11.8009 4.23524C11.7316 4.18028 11.6491 4.14465 11.5616 4.13198L8.37162 3.66898L6.94562 0.778985C6.90435 0.695252 6.84048 0.624742 6.76121 0.575437C6.68195 0.526132 6.59046 0.5 6.49712 0.5C6.40377 0.5 6.31229 0.526132 6.23302 0.575437C6.15376 0.624742 6.08988 0.695252 6.04862 0.778985L4.62212 3.66898Z",
    fill: "#26C64B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_4463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.1df098ad5d5692cb7f11a4b15420517f.svg";
export { ForwardRef as ReactComponent };